export default function getHoursLeft(expires) {
  return Math.round((expires - Date.now()) / 3600000)
}
